<template>
  <v-tooltip :text="_tooltip" location="top">
    <template v-slot:activator="{ props }">
      <v-btn v-bind="props" :color="value_ ? highlightColor_ : ''" @click="value_ = true" :icon="_icon" variant="plain" :class="_buttonClass" />
    </template>
  </v-tooltip>
</template>
<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    color: String,
    highlightColor: String,
    value: Boolean,
    tooltip: String,
    icon: String,
    buttonClass: String
  }
})
export default class IconToggle extends Vue {
  public inheritAttrs = false
  public color!: string
  public highlightColor!: string
  public value!: boolean
  public val: boolean = false
  public tooltip!: string
  public icon!: string
  public buttonClass!: string

  mounted() {
    this.val = this.value 
  }

  get value_(): boolean {
    if (this.value === undefined) {
      return false
    }
    return this.val
  }

  set value_(v: boolean) {
    this.val = !this.val
    this.$emit('value', this.val)
  }

  get color_(): string {
    let { color } = this
    if (color === undefined) {
      color = ''
    }
    if (this.value_) {
      return ''
    }
    return color
  }

  get highlightColor_(): string {
    let { color } = this
    if (color === undefined) {
      color = ''
    }
    if (this.value_) {
      return this.highlightColor ?? 'secondary'
    }
    return ''
  }

  get _tooltip(): string {
    if (this.tooltip != null) {
      return this.tooltip
    }
    return 'Toggle options'
  }

  get _icon(): string {
    if (this.icon != null) {
      return this.icon
    }
    return 'mdi-cog-outline'
  }

  get _buttonClass(): string {
    return this.buttonClass ?? ''
  }
}
</script>
<style lang="scss">
.clickable {
  cursor: pointer;
  &::before {
    cursor: pointer;
  }
}
</style>
